import { program } from 'commander';
import pkg from '../package.json';
import * as commands from './commands';

const cli = program
	.name(pkg.name)
	.description(pkg.description)
	.version(pkg.version)
	.addCommand(commands.add)
	.addCommand(commands.auth)
	.addCommand(commands.build, { hidden: true })
	.addCommand(commands.exec)
	.addCommand(commands.init)
	// .addCommand(commands.test)
	.addCommand(commands.update)
	.addCommand(commands.setup);

export { cli };
